module.exports = __webpack_public_path__ + "static/p1-18b74853ec9f376d086465af61d9d9c2.jpg";